import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormUpdate, IQuestionComponent } from '../question.model';
import { VideoCapturePresenter } from './video-capture.presenter';

import { VideoCaptureQuestionParams } from './video-capture.model';
import { JuiSkeletonLoader } from '@jump-tech-frontend/core-components-angular';
import { VideoPlayerComponent } from './video-player/video-player.component';

@Component({
  selector: 'question-video-capture',
  templateUrl: './video-capture.component.html',
  imports: [ReactiveFormsModule, VideoPlayerComponent, JuiSkeletonLoader],
  providers: [VideoCapturePresenter],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./video-capture.component.scss']
})
export class VideoCaptureComponent implements IQuestionComponent {
  private readonly presenter = inject(VideoCapturePresenter);
  public params = input.required<VideoCaptureQuestionParams>();
  @Output() formChange: EventEmitter<FormUpdate> = new EventEmitter<FormUpdate>();

  public vm = computed(() => {
    return this.presenter.load(this.params());
  });

  public async updateRecordedValue($event: { id: string | undefined; value: string | null }) {
    const formChangeValue = this.vm().videoSrc.map(vs => {
      return vs.id === $event.id ? $event.value : vs.src;
    });
    const isNewVideo = !this.vm().videoSrc.some(vs => vs.id === $event.id);
    if (isNewVideo) {
      formChangeValue.push($event.value);
    }
    this.formChange.emit({
      key: this.params().key,
      value: formChangeValue.filter(vs => !!vs)
    });
  }
}
